import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/Main.vue'
import ReportGuide from '@/pages/ReportGuide.vue'
import Reporting from '@/pages/Reporting.vue'
import ReportSecond from '@/pages/ReportSecond.vue'
import ReportSecond02 from '@/pages/ReportSecond02.vue'
import ReportComplete from '@/pages/ReportComplete.vue'
import ReportInquiry from '@/pages/ReportInquiry.vue'
import InquiryPage from '@/pages/InquiryPage.vue'
import AdminLogin from '@/pages/AdminLogin.vue'
import AdminInquiry from '@/pages/AdminInquiry.vue'
import AdminInquiryPage from '@/pages/AdminInquiryPage.vue'
import AdminReport from '@/pages/AdminReport.vue'
import PageNotFound from '@/pages/PageNotFound'
import AuditPopup from '@/pages/AuditPopup.vue'
import AuditPopup2 from '@/pages/AuditPopup2.vue'
import AdminGroup from '@/pages/AdminGroup.vue'
import AdminManager from '@/pages/AdminManager.vue'
import AdminMenu from '@/pages/AdminMenu.vue'
import AdminGroupAuth from '@/pages/AdminGroupAuth.vue'
import AdminCompanyAuth from '@/pages/AdminCompanyAuth.vue'
import SessionTimeout from '@/pages/SessionTimeout.vue'
Vue.use(Router)
const body = document.getElementsByTagName('body')[0]
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/reportguide',
      name: 'ReportGuide',
      component: ReportGuide
    },
    {
      path: '/reporting',
      name: 'Reporting',
      component: Reporting
    },
    {
      path: '/reportsecond',
      name: 'ReportSecond',
      component: ReportSecond
    },
    {
      path: '/reportsecond02',
      name: 'ReportSecond02',
      component: ReportSecond02
    },
    {
      path: '/reportcomplete',
      name: 'ReportComplete',
      component: ReportComplete
    },
    {
      path: '/reportinquiry',
      name: 'ReportInquiry',
      component: ReportInquiry
    },
    {
      path: '/inquirypage',
      name: 'InquiryPage',
      component: InquiryPage
    },
    {
      path: '/adminlogin',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/admininquiry',
      name: 'AdminInquiry',
      component: AdminInquiry
    },
    {
      path: '/admininquirypage',
      name: 'AdminInquiryPage',
      component: AdminInquiryPage
    },
    {
      path: '/adminreport',
      name: 'AdminReport',
      component: AdminReport
    },
    {
      path: '/auditpopup',
      name: 'AuditPopup',
      component: AuditPopup
    },
    {
      path: '/auditpopup2',
      name: 'AuditPopup2',
      component: AuditPopup2
    },
    {
      path: '/admingroup',
      name: 'AdminGroup',
      component: AdminGroup
    },
    {
      path: '/adminmanager',
      name: 'AdminManager',
      component: AdminManager
    },
    {
      path: '/adminmenu',
      name: 'AdminMenu',
      component: AdminMenu
    },
    {
      path: '/admingroupauth',
      name: 'AdminGroupAuth',
      component: AdminGroupAuth
    },
    {
      path: '/admincompanyauth',
      name: 'AdminCompanyAuth',
      component: AdminCompanyAuth
    },
    {
      path: '/sessiontimeout',
      name: 'SessionTimeout',
      component: SessionTimeout
    },
    {
      path: '*',
      component: PageNotFound
    }
  ],
  scrollBehavior (to, from) {
    if (to.hash !== '#intro-br') {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 })
        }, 0)
        body.classList.remove('overflow')
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js